<template>
    <router-link :to="`/thanks-cards/${thanksCard.id}`">
        <div
            class="px-6 py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class=" flex items-center">
                <div class="flex items-center mr-8">
                    <span class="text-sm font-medium mr-4">{{
                        thanksCard.author && thanksCard.author.name
                    }}</span>
                    <svg
                        class="flex-1 w-6 h-6 text-gray-300"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                    </svg>
                    <span class="text-sm font-medium ml-4">{{
                        thanksCard.giver && thanksCard.giver.name
                    }}</span>
                </div>
                <h3 class="flex-1">{{ thanksCard.title }}</h3>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['thanksCard'],
}
</script>
